import * as React from "react"

function SvgFeatherArrowDownLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather-arrow-down-left_svg__feather feather-arrow-down-left_svg__feather-arrow-down-left"
      {...props}
    >
      <path d="M17 7L7 17M17 17H7V7" />
    </svg>
  )
}

export default SvgFeatherArrowDownLeft
